import type { ComponentRadius } from "@overmap-ai/blocks"
import { createContext } from "react"

import type { MentionListSize, MentionListVariant } from "./typings"

export interface IMentionListContext<TItem> {
	selectItem: (item: TItem) => void
	isActive: (item: TItem) => boolean
	empty: boolean
	// style props
	size: MentionListSize
	variant: MentionListVariant
	radius: ComponentRadius
}

export const MentionListContext = createContext({} as IMentionListContext<never>)
